module.exports = __webpack_public_path__ + "img/zhixing.7e6989ed.png";